import {Component, ElementRef, ViewChild, inject} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {MessageService} from "../../services/services/message.service";
import {BugReportDialogComponent} from "../../../shared/dialogs/bug-report-dialog/bug-report-dialog.component";
import {AlertEnum} from "../../models/Enums/AlertEnum";
import {MatIcon} from "@angular/material/icon";
import {KeyValuePipe} from "@angular/common";

@Component({
	selector: "app-message",
	templateUrl: "./message.component.html",
	styleUrls: ["./message.component.scss"],
	imports: [MatIcon, KeyValuePipe],
})
export class MessageComponent {
	public messageService = inject(MessageService);
	private readonly dialog = inject(MatDialog);
	readonly alertEnum = AlertEnum;

	@ViewChild("mepSnackbar") private snackbar?: ElementRef<HTMLElement>;

	ngDoCheck() {
		const el = this.snackbar?.nativeElement;
		if (!el) return;

		const hasMessages = Object.keys(this.messageService.messages).length > 0;
		const isOpen = el.matches(":popover-open");

		if (hasMessages && !isOpen) {
			el.showPopover();
		} else if (!hasMessages && isOpen) {
			el.hidePopover();
		}
	}

	deleteMessage(key: string) {
		const feedback = this.messageService.remove(key);
		if (feedback) {
			this.dialog.open(BugReportDialogComponent, {
				disableClose: false,
				width: "50rem",
				panelClass: "mep-dialog",
				backdropClass: "light-backdrop",
				data: feedback,
			});
		}
	}
	containsPermanent() {
		return Object.values(this.messageService.messages).some((m) => m.isPermanent);
	}

	isLightModeWarning(alert: AlertEnum): boolean {
		const documentElement = document.documentElement;
		return (
			alert === AlertEnum.WARNING &&
			!documentElement.classList.contains("dark-mode-active") &&
			!documentElement.hasAttribute("data-darkreader-mode") &&
			documentElement.getAttribute("data-darkreader-scheme") !== "dark"
		);
	}
}
